module.exports = __webpack_public_path__ + "img/252.65c4a090.png";